import { Injectable } from '@angular/core';
import { EventQueueService } from '../event-queue/event-queue.service';

@Injectable({ providedIn: 'root' })
export class InitializeQueueService {
  private readonly callbacks = new Map<string, (contexto: Record<string, unknown>) => void>();
  private readonly provedoresProntos = new Set<string>();

  constructor(private readonly eventQueue: EventQueueService) {}

  registrarCallback(nome: string, callback: (contexto: Record<string, unknown>) => void): void {
    this.callbacks.set(nome, callback);
  }

  notificarPronto(nome: string): void {
    this.provedoresProntos.add(nome);
    const callback = this.callbacks.get(nome);
    if (!callback) return;
    const eventos = this.eventQueue.drainByName(nome);
    console.info(`[GA4 FILA] Provedor "${nome}" pronto → drenando ${eventos.length} evento(s)`);
    for (const evento of eventos) {
      console.info('[GA4 FILA] → enviando da fila:', evento.contexto);
      callback(evento.contexto);
    }
  }

  isProvedorPronto(nome: string): boolean {
    return this.provedoresProntos.has(nome);
  }
}
